import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import i18n from '../../i18n';
import Grid from '../components/Grid';
import PageHeader from '../components/PageHeader';
import Spinner from '../components/Spinner';
import DataSource from '../util/DataSource';
import { filterDate } from '../util/GridHelpers';
import { formatCurrency, formatDate, formatUnitPrice, val } from '../util/HelpfulFunctions';
import SessionManager from '../util/SessionManager';


class ProductInfo extends Component {

    constructor(props) {
        super(props);

        this.state = {
            isBusy: true
        }

        this.renderCommands = this.renderCommands.bind(this);
        this.renderMobileCell = this.renderMobileCell.bind(this);
    }

    componentDidMount() {
        this.getData();
    }

    render() {
        return (
            <div>
                {this.renderHeader()}
                {this.renderContent()}
            </div>
        );
    }


    renderHeader() {
        if (!this.state.item)
            return;

        return (
            <PageHeader title={`${this.state.item.Description} (${this.state.item.ItemCode})`}
                        sideContent={this.renderCommands} />
        );
    }

    renderCommands() {
        return (
            <div className="btn btn-success" onClick={() => this.props.history.goBack()}>Επιστροφή</div>
        )
    }

    renderContent() {
        if (this.state.isBusy) {
            return(<Spinner/>);
        }

        return (
            <div className="card mt-3 p-4 col-sm-12 col-md-12 col-lg-8 col-xl-8">
                <div className="color-primary font-weight-bold ml-2 mb-4">{i18n.t("Ιστορικό τιμών")}</div>
                {this.renderPriceHistory()}
            </div>
        );
    }

    renderPriceHistory() {
        if (!this.state.priceHistory)
            return;
        
        const columns = [
            {
                accessor: "Date",
                Header: i18n.t("Ημερομηνία"),
                headerClassName: "text-center",
                dataType: "date",
                className: "text-center m-auto",
                filterMethod: filterDate,
                Cell: this.renderStdCell
            },
            {
                accessor: "UnitId",
                Header: i18n.t("ΜΜ"),
                headerClassName: "text-center",
                className: "text-center m-auto",
                maxWidth: 150,
                Cell: this.renderStdCell
            },
            {
                accessor: "UnitPrice",
                Header: i18n.t("Τιμή"),
                headerClassName: "text-center",
                className: "text-center m-auto",
                dataType: "price",
                filterable: false,
                Cell: this.renderStdCell
            }
        ];
        
        return (
            <Grid data={this.state.priceHistory}
                filterable={true}
                minRows={0}
                defaultPageSize={Math.min(10, val(this.state.priceHistory.length, 10))}
                className="-striped -highlight"
                columns={columns}
                responsive={[
                    {
                        breakpoint: 768,
                        filterable: false,
                        columns: [
                            {
                                Header: "",
                                Cell: this.renderMobileCell
                            }
                        ]
                    }
                ]}>

            </Grid>
        )
    }


    renderStdCell(cellInfo) {

        var cellValue = cellInfo.value;

        if (cellInfo.column.dataType) {
            switch (cellInfo.column.dataType) {
                case "date":
                    cellValue = formatDate(cellValue);
                    break;

                case "currency":
                    cellValue = formatCurrency(cellValue);
                    break;
                
                case "price":
                    cellValue = formatUnitPrice(cellValue)
            }
        }

        var className = cellInfo.column.className ? cellInfo.column.className : "";
        return (
            <div contentEditable={false} suppressContentEditableWarning>
                <span className={className}>{cellValue}</span>
            </div>
        );
    }

    renderMobileCell(cellInfo) {

        var price = this.state.priceHistory[cellInfo.index];

        return (
            <div className="d-flex" contentEditable={false} suppressContentEditableWarning>
                <div className="col-6 text-center">{formatDate(price.Date)}</div>
                <div className="col-6 text-center">{`${formatUnitPrice(price.UnitPrice)} / ${price.UnitId}`}</div>
            </div>
        )
    }

    async getData() {

        this.setState({ isBusy: true });
        try {
            
            if (!this.props.match.params)
                return;

            var itemId = this.props.match.params.itemId;

            var item = await DataSource.load("Item", itemId);
            var priceHistory = await DataSource.query("PriceHistory", { filter: `ItemId eq "${itemId}" and TraderId eq "${SessionManager.salesPointId}"`, orderBy: "Date desc", top: 30 });
            
            this.setState({item: item, priceHistory: priceHistory})
        }
        finally {
            this.setState({ isBusy: false });
        }
    }
}

export default withRouter(ProductInfo);

